import { getRequest, postRequest } from 'utils/request';

export const listTradeOpsIssues = (query) => getRequest(`/issues`, query);

export const archiveTradeOpsIssues = (body) => postRequest(`/issues/close`, body);

export const reopenTradeOpsIssues = (body) => postRequest(`/issues/reopen`, body);
